// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"866c270b","453":"7d877728"}[chunkId] + ".chunk.js";
};